module.exports = __webpack_public_path__ + "static/media/comment-smile.9cb48f19.svg";